// Meta Pixel helper — Facebook Pixel ID for PORTUGUÉS 360
// Inyecta el snippet oficial de Meta sin depender de paquetes de terceros.

export const PIXEL_ID = '1545009850674181'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
    requestIdleCallback?: (cb: () => void) => number
    cancelIdleCallback?: (id: number) => void
  }
}

let initialized = false

export const initPixel = () => {
  if (typeof window === 'undefined' || initialized) return
  try {
    ;(function (f: any, b: any, e: any, v: any) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e)
      t.async = !0
      t.src = v
      // Swallow any load error so the page never crashes
      t.onerror = function () {
        /* noop */
      }
      const s = b.getElementsByTagName(e)[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        b.head.appendChild(t)
      }
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )

    if (typeof window.fbq === 'function') {
      window.fbq('init', PIXEL_ID)
      window.fbq('track', 'PageView')
    }
    initialized = true
  } catch (err) {
    // Pixel must NEVER break the page
    // eslint-disable-next-line no-console
    console.warn('Meta Pixel init failed', err)
  }
}

const safeTrack = (event: string, params?: Record<string, any>) => {
  if (typeof window === 'undefined') return
  try {
    if (typeof window.fbq === 'function') {
      window.fbq('track', event, params)
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('Meta Pixel track failed', err)
  }
}

export const trackInitiateCheckout = (params?: {
  value?: number
  currency?: string
  content_name?: string
}) => {
  safeTrack('InitiateCheckout', { currency: 'ARS', ...params })
}

export const trackViewContent = (params?: {
  content_name?: string
  value?: number
  currency?: string
}) => {
  safeTrack('ViewContent', { currency: 'ARS', ...params })
}

export const trackLead = (params?: { content_name?: string }) => {
  safeTrack('Lead', params)
}
